import FreshDeskTicketList from './freshdeskticketlistmodel-list-screen.vue';

export default {
    components: {
        'freshdesk_tickets_list': FreshDeskTicketList
    },

    data: function () {
        return {
            loading: false,
            appId: this.$route.params.id ?? 0,
            model: this.emptyModel(),
        }
    },

    computed: {

    },

    methods: {
        refreshScreen() {
            this.appId = this.$route.params.id ?? 0;
            this.onLoadModelDataSource();
        },

        emptyModel() {
            return {
                AppId: 0,
            }
        },

        async onLoadModelDataSource() {
            try {
                this.loading = true;

                let url = '/api/ui/freshdesk_tickets_applications/load/' + this.appId;
                let response = await this.$http.get(url);
                this.model = response.body;

                this.$refs.freshdesk_tickets_list.channelSettings = {
                    ApplicationId: this.model.AppId
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },
    },

    watch: {
        // Reload data if the route changed manually from browser address bar
        $route: 'refreshScreen'
    },

    mounted: function () {
        this.refreshScreen();
    }
}